import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/app/store';

// Define a type for the slice state
interface CanvasState {
  uiPayload: Record<string, any> | null;
  isLoading: boolean;
}

const initialState: CanvasState = {
  uiPayload: null,
  isLoading: false,
};

export const canvasSlice = createSlice({
  name: 'canvas',
  initialState,
  reducers: {
    setUiPayload: (state, action: PayloadAction<Record<string, any> | null>) => {
      state.uiPayload = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setUiPayload, setLoading } = canvasSlice.actions;

export const selectCanvasUiPayload = (state: RootState) => state.canvas.uiPayload;
export const selectIsCanvasLoading = (state: RootState) => state.canvas.isLoading;

export default canvasSlice.reducer;
